import React from "react";
import {Link} from "react-router-dom";

/**
 * The colophon. A paper signs off with who printed it and what it is; this one
 * also has to admit it is a demo, because the stories are synthetic. Saying so
 * plainly is better craft than burying it.
 */
function Footer() {
  const year = new Date().getFullYear();

  const columns = [
    {
      title: "Sections",
      links: [
        {label: "Front page", to: "/"},
        {label: "Explore", to: "/explore"},
        {label: "All stories", to: "/stories"},
        {label: "Your profile", to: "/profile"},
      ],
    },
  ];

  return (
    <footer className="mt-8 border-t-2 border-ink bg-paper">
      <div className="container py-10">
        <div className="grid gap-8 sm:grid-cols-[minmax(0,2fr)_minmax(0,1fr)]">
          <div>
            <p className="font-serif text-h2 font-bold leading-none tracking-[-0.02em] text-ink">
              Pembury
            </p>
            <p className="mt-1.5 font-sans text-kicker uppercase tracking-[0.34em] text-masthead">
              The Daily Record
            </p>
            <p className="mt-4 max-w-md text-body text-ink-secondary">
              A demonstration newspaper. Every story, byline and comment here is
              synthetic, generated to show how{" "}
              <a
                href="https://neuronsearchlab.com"
                className="font-medium text-ink underline decoration-masthead/40 underline-offset-2 transition-colors duration-150 ease-out hover:decoration-masthead"
              >
                NeuronSearchLab
              </a>{" "}
              ranks a real catalogue in real time.
            </p>
          </div>

          {columns.map((column) => (
            <nav key={column.title} aria-label={column.title}>
              <p className="font-sans text-kicker uppercase tracking-[0.09em] text-ink-tertiary">
                {column.title}
              </p>
              <ul className="mt-3 space-y-2">
                {column.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="font-sans text-body text-ink-secondary transition-colors duration-150 ease-out hover:text-ink"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-8 flex flex-col gap-2 border-t border-rule pt-4 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-sans text-meta text-ink-muted">
            &copy; {year} NeuronSearchLab
          </p>
          <p className="font-sans text-meta text-ink-muted">
            Ranked live · Personalised edition
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
